module.exports = __webpack_public_path__ + "static/landing-img-c-f336a8b51fc28d3c8b450c493f234cd9.svg";